<template>
  <div>
    <Form
      ref="mailTemplateForm"
      :model="mailTemplateForm"
      :rules="mailTemplateRules"
      label-position="top"
      class="fit-to-content"
    >
      <Row :gutter="32" style="width: 800px;">
        <i-col :xs="8">
          <FormItem prop="TemplateType" label="Message template type">
            <AutoComplete
              clearable
              v-model="mailTemplateForm.TemplateType"
              :data="templates"
              @on-select="getMailTemplateDetails"
              @on-change="handleTypeChange"
              @on-clear="reset"
              :filter-method="filterMethod"
              placeholder="Select template"
            ></AutoComplete>
          </FormItem>
        </i-col>
        <i-col :xs="8">
          <FormItem prop="Title" label="Title">
            <Input v-model="mailTemplateForm.Title" placeholder="Title" />
          </FormItem>
        </i-col>
        <i-col :xs="6">
          <FormItem prop="Language" label="Language">
            <Select
              v-model="mailTemplateForm.Language"
              filterable
              placeholder="Select language"
              class="capitalize"
              @on-change="getMailTemplateDetails"
            >
              <Option
                v-for="lang in languages"
                :value="lang.LanguageCode"
                :key="lang.LanguageCode"
                class="capitalize"
              >{{ lang.LanguageName }}</Option>
            </Select>
          </FormItem>
        </i-col>
        <i-col :xs="24">
          <FormItem prop="Contents" label="Enter template text here">
            <editor-content v-model="test" :editor="editor" class="template-editor" />
            <p class="input-info">
              * Supported macros: %ContactMail | %MailValidationURL | %WinkyID |
              %WinkyName | %resetURL | %parentalcode
            </p>
          </FormItem>
        </i-col>
        <i-col :xs="24">
          <Button
            type="primary"
            class="right"
            @click="updateTemplate"
            :loading="submitLoading"
            style="margin-left: 8px"
            v-if="mailTemplateForm._id"
          >
            <span v-if="!submitLoading">Update</span>
            <span v-else>Processing...</span>
          </Button>
          <Button
            type="primary"
            class="right"
            @click="createNewTemplate"
            :loading="submitLoading"
            style="margin-left: 8px"
            v-else
          >
            <span v-if="!submitLoading">Create</span>
            <span v-else>Processing...</span>
          </Button>
        </i-col>
      </Row>
    </Form>
  </div>
</template>

<script>
import { bus } from "../../main";
import { Editor, EditorContent } from "tiptap";
import { getSupportedLanguages } from "../../_services/language.service";
import {
  getTemplates,
  getTemplateDetails,
  updateTemplateDetails,
  createTemplate
} from "../../_services/template.service";

export default {
  data() {
    return {
      test: "",
      editor: null,
      submitLoading: false,
      mailTemplateForm: {
        TemplateType: "",
        Language: "en",
        Contents: "",
        Title: ""
      },
      templates: [],
      timeout: null,
      mailTemplateRules: {
        TemplateType: [
          {
            required: true,
            message: "Please fill in the template type",
            trigger: "blur"
          }
        ]
        // Contents: [
        //     { required: true, message: 'Please fill in contents', trigger: 'blur' }
        // ],
      },
      templateTypes: ["Mail validation", "Winky change of ownership"],
      languages: []
    };
  },
  components: {
    EditorContent
  },
  methods: {
    getMailTemplateDetails() {
      this.$refs.mailTemplateForm.validateField("TemplateType");
      if (
        this.mailTemplateForm.TemplateType &&
        this.mailTemplateForm.Language
      ) {
        let cpTemplateData = Object.assign({}, this.mailTemplateForm);
        delete cpTemplateData.Contents;
        getTemplateDetails(cpTemplateData)
          .then(res => {
            this.mailTemplateForm._id = res.data.data._id;
            this.mailTemplateForm.Contents = res.data.data.Contents;
            // this.$refs.mailTemplateForm.validateField('Contents');
            this.mailTemplateForm.Title = res.data.data.Title;
            this.editor.destroy();
            this.editor = new Editor({
              content: res.data.data.Contents,
              onUpdate: ({ getHTML }) => {
                let htmlContent = getHTML();
                if (htmlContent === "<p></p>") {
                  this.mailTemplateForm.Contents = "";
                } else {
                  this.mailTemplateForm.Contents = htmlContent;
                }
              }
            });
          })
          .catch(err => {
            delete this.mailTemplateForm._id;
            this.mailTemplateForm.Contents = "";
            this.mailTemplateForm.Title = "";
            this.editor.destroy();
            this.editor = new Editor({
              onUpdate: ({ getHTML }) => {
                let htmlContent = getHTML();
                if (htmlContent === "<p></p>") {
                  this.mailTemplateForm.Contents = "";
                } else {
                  this.mailTemplateForm.Contents = htmlContent;
                }
              }
            });
          });
      }
    },
    handleTypeChange(value) {
      let vm = this;
      if (value.length) {
        clearTimeout(vm.timeout);
        vm.timeout = setTimeout(function() {
          vm.getMailTemplateDetails();
        }, 700);
      } else {
        this.reset();
      }
    },
    getUILanguageList() {
      getSupportedLanguages()
        .then(res => {
          this.languages = res.data.data;
          this.mailTemplateForm.Language = res.data.data[0].LanguageCode;
        })
        .catch(err => {
          bus.$emit("requestError", err);
        });
    },
    filterMethod(value, option) {
      return option.toUpperCase().indexOf(value.toUpperCase()) !== -1;
    },
    getMessageTemplates() {
      getTemplates()
        .then(res => {
          this.templates = res.data.data.reduce((unqTemplates, template) => {
            if (unqTemplates.indexOf(template.TemplateType) === -1) {
              unqTemplates.push(template.TemplateType);
            }
            return unqTemplates;
          }, []);
        })
        .catch(err => {
          bus.$emit("requestError", err);
        });
    },
    updateTemplate() {
      this.$refs.mailTemplateForm.validate(valid => {
        if (valid) {
          this.submitLoading = true;
          updateTemplateDetails(this.mailTemplateForm)
            .then(res => {
              this.submitLoading = false;
              this.$Message.success("Template successfully updated");
            })
            .catch(err => {
              bus.$emit("requestError", err);
              this.submitLoading = false;
              this.$Message.error(
                "Failed to update template. Please try again later."
              );
            });
        }
      });
    },
    createNewTemplate() {
      this.$refs.mailTemplateForm.validate(valid => {
        if (valid) {
          let cpTemplateForm = Object.assign({}, this.mailTemplateForm);
          this.submitLoading = true;
          cpTemplateForm.Contents =
            "<html><head></head><body>" +
            this.mailTemplateForm.Contents +
            "</body></html>";
          createTemplate(cpTemplateForm)
            .then(res => {
              this.submitLoading = false;
              this.getMessageTemplates();
              this.mailTemplateForm._id = res.data.data._id;
              this.mailTemplateForm.Contents = res.data.data.Contents;
              // this.$refs.mailTemplateForm.validateField('Contents');
              this.mailTemplateForm.Title = res.data.data.Title;

              this.editor.destroy();
              this.editor = new Editor({
                content: res.data.data.Contents,
                onUpdate: ({ getHTML }) => {
                  let htmlContent = getHTML();
                  if (htmlContent === "<p></p>") {
                    this.mailTemplateForm.Contents = "";
                  } else {
                    this.mailTemplateForm.Contents = htmlContent;
                  }
                }
              });
              this.$Message.success("Template successfully created");
            })
            .catch(err => {
              this.submitLoading = false;
              this.$Message.error(
                "Failed to create new template. Please try again later."
              );
            });
        }
      });
    },
    reset() {
      this.mailTemplateForm._id = null;
      this.editor.destroy();
      this.editor = new Editor({
        onUpdate: ({ getHTML }) => {
          let htmlContent = getHTML();
          if (htmlContent === "<p></p>") {
            this.mailTemplateForm.Contents = "";
          } else {
            this.mailTemplateForm.Contents = htmlContent;
          }
        }
      });
    }
  },
  mounted() {
    this.editor = new Editor({
      content: "",
      onUpdate: ({ getHTML }) => {
        let htmlContent = getHTML();
        if (htmlContent == "<p></p>") {
          this.mailTemplateForm.Contents = "";
        } else {
          this.mailTemplateForm.Contents = htmlContent;
        }
      }
    });
    this.getUILanguageList();
    this.getMessageTemplates();
  },
  beforeDestroy() {
    this.editor.destroy();
  }
};
</script>

<style scoped>
.session-input {
  width: 300px;
}
</style>
